import { jsx as _jsx } from "react/jsx-runtime";
import find from 'lodash/find';
import has from 'lodash/has';
import React from 'react';
import { useSelector } from 'react-redux';
import * as selectors from '../../../selectors';
import Field from './Field';
const HideableField = ({ id, formValues })=>{
    const organizationTemplate = useSelector(selectors.organizationTemplate);
    const fieldDefinition = find(organizationTemplate, {
        name: id
    });
    const isHidden = !has(fieldDefinition, 'isMandatory');
    if (isHidden) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Field, {
        id: id,
        formValues: formValues
    });
};
export default HideableField;
